import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Obra',
    path: 'obra',
    name: 'obra',
    component: () => import('@/views/gestao/obra/Index.vue'),
    goesToMenu: true,
    meta: {
      permissions: [EPermissoes.CadastroObra],
      grupos: [],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusao de Obra',
    path: 'obra/incluir',
    parent: 'obra',
    name: 'obrainsert',
    component: () => import('@/views/gestao/obra/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'obra',
      permissions: [EPermissoes.CadastroObra],
      grupos: []
    }
  },
  {
    description: 'Edicao de Obra',
    path: 'obra/editar/:id',
    parent: 'obra',
    name: 'obraupdate',
    component: () => import('@/views/gestao/obra/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'obra',
      permissions: [EPermissoes.CadastroObra],
      grupos: []
    }
  }
];
